// extracted by mini-css-extract-plugin
export default {"language_selector":"LanguageSelectorWrapper_language_selector__hsux2"};